import { render, staticRenderFns } from "./workflow-owners-modal.vue?vue&type=template&id=e997cc2e&scoped=true"
import script from "./workflow-owners-modal.vue?vue&type=script&lang=js"
export * from "./workflow-owners-modal.vue?vue&type=script&lang=js"
import style0 from "./workflow-owners-modal.vue?vue&type=style&index=0&id=e997cc2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e997cc2e",
  null
  
)

export default component.exports